export default {
    data() {
        return {
            isMobileDevice: false,
        };
    },
    methods: {
        isMobile() {
            return window.innerWidth <= 768; // Sesuaikan breakpoint
        },

        handleResize() {
            this.isMobileDevice = this.isMobile();
        },
    },
    mounted() {
        this.isMobileDevice = this.isMobile();
        window.addEventListener("resize", this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.handleResize);
    },
};